/* eslint-disable import/no-anonymous-default-export */
export default {
    domain: [
		'I. Depression:',
		'II. Anger:',
		'III. Mania:',
		'IV. Anxiety:',
		'V. Somatic Symptoms:',
		'VI. Suicidal Ideation:',
		'VII. Psychosis:',
		'VIII. Sleep Problems:',
		'IX. Memory:',
		'X. Repetitive Thoughts and Behaviors:',
		'XI. Dissociation:',
		'XII. Personality Functionin:',
		'XIII. Substance Use:'
	]
}